import { Injectable, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {
  HAMMER_GESTURE_CONFIG,
  HammerGestureConfig,
  HammerModule,
} from '@angular/platform-browser';
import { CarouselComponent } from './carousel.component';
import { CarouselSlideComponent } from './carousel-slide/carousel-slide.component';

// src: https://github.com/gabrielbusarello/material2-carousel/blob/master/projects/carousel/src/lib/carousel.module.ts
@Injectable()
export class CarouselHammerConfig extends HammerGestureConfig {
  overrides = {
    pan: {
      direction: 30, // DIRECTION_ALL = 30
    },
    pinch: { enable: false },
    rotate: { enable: false },
  };
}
@NgModule({
  declarations: [CarouselComponent, CarouselSlideComponent],
  imports: [CommonModule, MatButtonModule, MatIconModule, HammerModule],
  exports: [CarouselComponent, CarouselSlideComponent],
})
export class CarouselModule {
  static forRoot(): ModuleWithProviders<CarouselModule> {
    return {
      ngModule: CarouselModule,
      providers: [
        // Workaround for Hammer https://github.com/angular/angular/issues/10541#issuecomment-300761387
        // CarouselModule.forRoot() must be imported once to enable slide by touching on
        { provide: HAMMER_GESTURE_CONFIG, useClass: CarouselHammerConfig },
      ],
    };
  }
}
